import Administration from "../../../customIcons/Modules/Administration.vue";

export default {
  name: "KisOverview",
  components: { Administration },
  data: () => ({}),
  async mounted() {},
  methods: {
    goTo(path) {
      this.$router.push(path);
    }
  },
  computed: {
    currentUser() {
      return this.$store.state.currentUser;
    },
    isBookingUser() {
      return this.currentUser?.scopes?.includes("role:booking") || this.isAdmin;
    },
    isBookingAdmin() {
      return (
        this.currentUser?.scopes?.includes("role:booking_admin") || this.isAdmin
      );
    },
    isAdmin() {
      return this.currentUser?.scopes?.includes("role:admin");
    }
  }
};
